import React, { useContext } from "react";
import {
  ClaimsActivityDashboardContext,
  ClaimsActivityGhostProviderScenarioTile,
  ClaimsActivityProviderScenarioTile,
} from "@app/projects/network-assessment/pci-dashboard/claims-activity";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";

export const ClaimsActivityDashboardScenarioView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsActivityContext = useContext(ClaimsActivityDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsActivityProviderScenarioTile
          data={claimsActivityContext.networkProviderScenarios}
          loading={claimsActivityContext.networkProviderScenariosLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
        />
      </div>
      <div className="row">
        <ClaimsActivityGhostProviderScenarioTile
          getSummaries={claimsActivityContext.getGhostScenarioWidgetData}
          loading={claimsActivityContext.ghostProviderScenarioCountiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          scenarioModel={claimsActivityContext.ghostProviderScenarioCountiesModel}
          summaryType={PciDashboardSummaryType.County}
        />
        <ClaimsActivityGhostProviderScenarioTile
          getSummaries={claimsActivityContext.getGhostScenarioWidgetData}
          loading={claimsActivityContext.ghostProviderScenarioSpecialtiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          scenarioModel={claimsActivityContext.ghostProviderScenarioSpecialtiesModel}
          summaryType={PciDashboardSummaryType.Specialty}
        />
      </div>
    </React.Fragment>
  );
}

export default ClaimsActivityDashboardScenarioView;
